import environment from "../environment/environment";

const base = environment.baseKey;

export const STORAGE_KEYS = {
  THEME: `${base}_theme`,
  USER: `${base}_user`,
} as const;

export type StorageKey = keyof typeof STORAGE_KEYS;
